import { MtUser, MtUserRegistered } from "server/models"
import { ActiveInactive, OrderType, OnlineUsers } from "client/utils"


export interface UserProps {
    userId: number
    hash?: string
}

export type UserValidation = { [key in keyof MtUser]?: string}
export type UserRegisteredValidation = { [key in keyof MtUserRegistered]?: string}

export interface UserList { [userId: number]: MtUser}
export interface UserFilters {
    status?: ActiveInactive
    search?: string
}

export interface UserState {
    userList: UserList
    userIds: readonly number[]
    userView: MtUser
    userEdit: MtUser

    onlineUsers: OnlineUsers

    sortColumn: keyof MtUser
    sortOrder: OrderType
    filters: UserFilters

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean
}

export const USER_LIST = "USER_LIST"
export const USER_IDS = "USER_IDS"
export const USER_VIEW = "USER_VIEW"
export const USER_EDIT = "USER_EDIT"

export const ONLINE_USERS = "ONLINE_USERS"

export const USER_SORT = "USER_SORT"
export const USER_FILTERS = "USER_FILTERS"

export const USER_RELOAD_LIST = "USER_RELOAD_LIST"
export const USER_RELOAD_VIEW = "USER_RELOAD_VIEW"
export const USER_RELOAD_EDIT = "USER_RELOAD_EDIT"
